import { StrictMode } from 'react';
import { ThemeProvider } from 'styled-components';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import theme from '@/styles/theme';
import GlobalStyle from '@/styles/GlobalStyle';
import App from './App';

export default function AppRoot() {
  return (
    <StrictMode>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <App />
        </ThemeProvider>
      </I18nextProvider>
    </StrictMode>
  );
}
